import { getAisUrl, getFisherUrl, getSquidUrl, getTunaUrl, postLogConf } from "../config/urlConfig";
import { fetchGet, fetchPost, fetchPostImg } from "../config/axiosConfig";
import store from "@/store/store";
import { postForm } from './../config/axiosConfig';

/**
 * 根据船舶的mmsi获取船舶信息
 */
export function uploadFisherData(token, title, center, level) {
    let url =
        getFisherUrl().uploadFisherUrl +
        "uid=" +
        token +
        "&fisher_title=" +
        title +
        "&fisher_center=" +
        center +
        "&fisher_level=" +
        level;
    let ret = fetchGet(url);
    return ret;
}

/**
 * 根据船舶的mmsi获取船舶信息
 */
export function uploadFisherDetailData(
    fid,
    points,
    color,
    featureType,
    remark
) {
    let coor = JSON.stringify(points);
    let url = getFisherUrl().uploadFisherDetailUrl;
    let data = new FormData();
    data.append("fid", fid);
    data.append("offices_ins", coor);
    data.append("color", color);
    data.append("feature_type", featureType);
    data.append("remark", remark);
    let ret = fetchPost(url, data);
    return ret;
}

/**
 * 更新用户密码
 */
export function updatePass(token, oldPass, pass) {
    let url = getFisherUrl().updatePassUrl;
    let data = new FormData();
    let sparam = `{"token":"${token}","oldpwd":"${oldPass}","newpwd":"${pass}"}`;
    data.append("s", sparam);
    let ret = fetchPost(url, data);
    return ret;
}

/**
 * 更新在线状态
 */
export function updateOnLineStatus(token, clientId) {
    let url = getFisherUrl().updateOnlineStatusUrl;
    let data = new FormData();
    let sparam = `{"userid":"${token}","clientid":"${clientId}"}`;
    data.append("s", sparam);
    let ret = fetchPost(url, data);
    return ret;
}

/**
 * 登出
 */
export function loginOut(token, clientId) {
    let url = getFisherUrl().loginOutUrl;
    let data = new FormData();
    let sparam = `{"userid":"${token}","clientid":"${clientId}"}`;
    data.append("s", sparam);
    let ret = fetchPost(url, data);
    return ret;
}

/**
 * 生成二维码
 */
export function getQrCode(img) {
    let url = getFisherUrl().getQrCodeUrl;
    let data = new FormData();
    data.append("img", img);
    let ret = fetchPostImg(url, data);
    return ret;
}

/**
 * zoujuan 发送邮件
 */

export function sendEmail(data) {
    let user = store.getters.getUser;
    // let url = "http://192.168.2.105:8090/fishser/admin/sendMail";
    let url = getFisherUrl().sendEmailUrl;
    let formData = new FormData();
    formData.append("from_userid", user.token);
    formData.append("from_username", user.name);
    formData.append("addressee_mailbox", data.emailReceiver);
    formData.append("theme", data.emailTheme);
    formData.append("content", data.emailContent);
    formData.append("enclosure_file", data.enclosure);
    return fetchPost(url, formData, "正在发送中");
}

/**
 * 登录验证
 */
export function loginCheck(data) {
    let url = getSquidUrl().loginCheckUrl;
    let formData = new FormData();
    formData.append("username", data.username);
    formData.append("password", data.password);
    return fetchPost(url, formData);
}

// 编辑自定义船名
export function updateShipName(data) {
    let token = store.getters.getUser.token
    let url = getFisherUrl().updateShipNameUrl
    // let url = "http://192.168.1.24:8088/fishser/admin/alertaisname";
    let formData = new FormData()
    formData.append('token', token)
    formData.append('mmsi', data.mmsi)
    formData.append('beforename', data.beforename)
    formData.append('aftername', data.aftername)
    return fetchPost(url, formData, '正在保存')
}

//保存日志
export function saveLogInfo(data) {
    let url = postLogConf();
    return fetchGet(url, data, false);
}

export function getNearestOceanTime(data) {
    let url = getFisherUrl().getNearestOceanTime
    return fetchPost(

        url, data,
        {

            headers: {

                "session": "101_qdkc26272MT936",
                "Content-Type": "application/json"
            }
        },
    )
}




// WEBPACK FOOTER //
// ./src/service/postData.js